var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-qrcode',{attrs:{"value":_vm.value,"margin":_vm.margin,"scale":_vm.scale}})
}
var staticRenderFns = []

export { render, staticRenderFns }